"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCTOR_AVAILABILITY_OVERRIDE_RESPONSE_EXAMPLE = exports.REQUEST_LEAVE_RESPONSE_EXAMPLE = exports.DOCTOR_LEAVE_RESPONSE_EXAMPLE = exports.DOCTOR_SCHEDULE_RESPONSE_EXAMPLE = void 0;
exports.DOCTOR_SCHEDULE_RESPONSE_EXAMPLE = {
    id: '70000000-0000-0000-0000-000000000001',
    tenantId: '11111111-1111-1111-1111-111111111111',
    doctorId: '22222222-2222-2222-2222-222222222222',
    departmentId: '44444444-4444-4444-4444-444444444444',
    branchId: '33333333-3333-3333-3333-333333333333',
    scheduleName: 'Dr. Rao — General OPD',
    effectiveFrom: '2026-08-01',
    effectiveTo: null,
    isActive: true,
    version: 1,
    createdAt: '2026-07-11T09:00:00.000Z',
    updatedAt: '2026-07-11T09:00:00.000Z',
};
exports.DOCTOR_LEAVE_RESPONSE_EXAMPLE = {
    id: '80000000-0000-0000-0000-000000000001',
    tenantId: '11111111-1111-1111-1111-111111111111',
    doctorId: '22222222-2222-2222-2222-222222222222',
    leaveFrom: '2026-08-10T00:00:00.000Z',
    leaveTo: '2026-08-12T00:00:00.000Z',
    reasonCode: null,
    reasonDescription: null,
    status: 'APPROVED',
    approvalMatrixId: null,
    approvedBy: null,
    approvedAt: '2026-07-11T09:00:00.000Z',
    createdAt: '2026-07-11T09:00:00.000Z',
    updatedAt: '2026-07-11T09:00:00.000Z',
};
exports.REQUEST_LEAVE_RESPONSE_EXAMPLE = {
    leave: exports.DOCTOR_LEAVE_RESPONSE_EXAMPLE,
    approverNotified: false,
};
exports.DOCTOR_AVAILABILITY_OVERRIDE_RESPONSE_EXAMPLE = {
    id: '90000000-0000-0000-0000-000000000001',
    tenantId: '11111111-1111-1111-1111-111111111111',
    doctorId: '22222222-2222-2222-2222-222222222222',
    fromDateTime: '2026-08-01T13:00:00.000Z',
    toDateTime: '2026-08-01T14:00:00.000Z',
    overrideType: 'BLOCKED',
    blockCategory: 'MAINTENANCE',
    reasonCode: null,
    reasonDescription: null,
    createdAt: '2026-07-11T09:00:00.000Z',
    updatedAt: '2026-07-11T09:00:00.000Z',
};
//# sourceMappingURL=doctor-availability.response.js.map